import { AsyncPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { map, Observable, startWith } from 'rxjs';
import { generateColorFromString } from '../../../utils/comman';
import { MatIconModule } from '@angular/material/icon';

export interface Option {
  name: string;
}

@Component({
  selector: 'app-input-select',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatIconModule,
  ],
  templateUrl: './input-select.component.html',
  styleUrl: './input-select.component.scss',
})
export class InputSelectComponent {
  options = input<Option[]>([]); // Accepts the list of options to display in autocomplete
  placeholder = input<string>(''); // Placeholder text for input field
  label = input<string>('');
  prefixIcon = input<string>('task');
  selectedOption = input<string>('');
  isDisplayColorOption = input<boolean>(false);
  onOptionChange = output<Option>(); // Emit the selected option

  myControl = new FormControl<string | Option>('');
  filteredOptions: Observable<Option[]>;

  ngOnInit() {
    if (this.selectedOption() !== undefined) {
      this.myControl.patchValue({
        name: this.selectedOption(),
      });
    }

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const name = typeof value === 'string' ? value : value?.name;
        const valueChange = name
          ? this._filter(name as string)
          : this.options().slice();
        if (name) {
          // When emit value changes, the options do not match the given option.
          this.onOptionChange.emit({ name: name });
        }
        this.updateValue();
        return valueChange;
      })
    );
  }

  updateValue() {
    // When value is empty then update the value of input
    if (this.myControl.value === '') {
      this.onOptionChange.emit({ name: '' });
    }
  }

  displayFn(option: Option): string {
    return option && option.name ? option.name : '';
  }

  private _filter(name: string): Option[] {
    const filterValue = name.toLowerCase();

    return this.options().filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onOptionSelected(option: Option): void {
    this.onOptionChange.emit(option);
  }

  generateColorFromString(str: string): string {
    return generateColorFromString(str);
  }
}
